import Vector from "../../Vector"
import ParticleEffectEntity, { ParticleEffectEntityOptions } from "./ParticleEffectEntity"

export type ManaSparkParticleEffectOptions = {} & ParticleEffectEntityOptions

export default class ManaSparkParticleEffect extends ParticleEffectEntity {

	static baseSize: 10

	constructor(options: ManaSparkParticleEffectOptions) {
		super({
			...options,

			symbol: '✨',
			size: 5 + (Math.random() * 5)
		})

		const addVelocity = new Vector((Math.random() * 10) + 2, 0).rotateToDeg(Math.random() * 360)

		this.velocity.add(addVelocity)

	}

}